<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="local_form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                    @changePage="changePage($event)" 
                    @debounceInput="debounceInput($event)"
                    :loading_records="loading_records"
                    ref="form_dynamic"
                    name="InstantUpdateModal"
                />
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'
import _ from 'lodash'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
        "global_api_rooms_pag"
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format: FormResources.form_format,
            single_object_copy: {...this.single_object},
            pagination: {},
            loading_records: false,
            search: '',
            initial_selected_room: {},
            local_form_format: []
        }
    },

    watch:{
        async 'single_object.room_id'(val)
        {
            if(val)
            {
                let json_request = {
                    filter: 'instant_inspection',
                    id: val,
                }

                const response = await this.get(`${this.rest_api}/${JSON.stringify(json_request)}`)

                if(response.status)
                {
                    if(response.data.inspection_templates.length)
                    {
                        this.array_options.inspection_template_id = response.data.inspection_templates
                        this.notyf.success('Templates available')
                        await this.assign_inspection_template(this.single_object.inspection_template_id)
                    }
                    else
                    {
                        this.array_options.inspection_template_id = []
                        // this.single_object.inspection_template_id = ''
                        this.notyf.error('No templates available')
                    }
                }
                else
                {
                    this.error_handling(response)
                } 
            }
        },
        async 'search'(val)
        {
            this.loadRecords(true, val)
        }
    },
    
    methods:{
        debounceInput:  _.debounce(function (e)  {
            this.search = e.value
        },800),

        async assign_inspection_template(val)
        {
            this.single_object.inspection_template_id = val
        },

        async setupForm(single_object) 
        {
            this.loader(true)

            const response = await this.get(`${this.rest_api}/get/inspection_rooms/${single_object.id}`)

            if(response.status)
            {
                this.single_object.room_id  = response.data.inspection_rooms[0].id || ''
                this.single_object.room     = response.data.inspection_rooms[0].name || ''
            }
            else
            {
                this.error_handling(response)
            }

            this.loader()

            this.initial_selected_room = {
                id: this.single_object.room_id,
                name: this.single_object.room
            }


            this.array_options['room_id'] = []
            this.pagination = {}
            this.page = 0
            this.search = ''
            this.$refs.form_dynamic.clearInputSearch()
            
            this.array_options['room_id'].push(this.initial_selected_room)

            this.loadRecords()
        },

        async loadRecords(reset_list, val) 
        {
                if(reset_list)
                {
                    this.array_options['room_id'] = []
                    this.pagination = {}
                    this.page = 0

                    if(!val)
                    {
                        this.array_options['room_id'].push(this.initial_selected_room)
                    }
                }

                if (this.array_options['room_id'].length >= this.pagination?.total) {
                    return;
                }

                this.loading_records = true

                this.page = this.page + 1

                const response = await this.post(this.global_api_rooms_pag, { page: this.page, search: this.search })
                if (response.status) {
                    let data = response.data

                    if (data.data.length) {
                        data.data.forEach((item) => {
                            if(item.id !== this.initial_selected_room.id || val)
                            {
                                this.array_options['room_id'].push(item)
                            }
                        })
                    }

                    this.pagination = data
                } else {
                    this.error_handling(response)
                }

                this.loading_records = false

        },

        changePage(event) {
            if (event.target.scrollTop + event.target.clientHeight >= (event.target.scrollHeight - 1)) {
                if (!this.loading_records) {
                    this.loadRecords()
                }
            }

        }
    },

    mounted()
    {
        this.local_form_format = JSON.parse(JSON.stringify(this.form_format));
        this.local_form_format[0].disabled = true
    }
    
}
</script>